import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-infinite-spinner',
  templateUrl: './infinite-spinner.component.html',
  styleUrls: ['./infinite-spinner.component.scss'],
})
export class InfiniteSpinnerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
